// Sign-up DEMO form (client-side only — shown until a real Contact Form 7
// shortcode is set in the Customizer): the same field validation as the
// prototype, then a fake success state. Nothing is sent anywhere.
import { $, $$, t, toast } from "./dom.js";

const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function initSignupDemo() {
  const form = $(".js-signup-form");
  if (!form) return;

  $$(".js-chip", form).forEach((chip) =>
    chip.addEventListener("click", () => chip.setAttribute("aria-pressed", chip.getAttribute("aria-pressed") === "true" ? "false" : "true"))
  );

  const flag = (input, bad) => {
    const wrap = input.closest(".fld");
    if (wrap) wrap.classList.toggle("is-invalid", bad);
    return !bad;
  };

  form.addEventListener("submit", (e) => {
    e.preventDefault();
    if ($('button[type="submit"]', form).disabled) return;
    const first = $("#suFirst", form);
    const last = $("#suLast", form);
    const email = $("#suEmail", form);
    const pass = $("#suPass", form);
    const consent = $("#suConsent", form);
    const consentErr = $(".js-consent-err", form);

    let ok = true;
    ok = flag(first, !first.value.trim()) && ok;
    ok = flag(last, !last.value.trim()) && ok;
    ok = flag(email, !emailPattern.test(email.value.trim())) && ok;
    ok = flag(pass, pass.value.length < 8) && ok;
    consentErr.classList.toggle("is-visible", !consent.checked);
    ok = consent.checked && ok;

    if (!ok) {
      toast(t("fixFields"));
      return;
    }
    // FAKE send: a short "creating account" state, then the success panel.
    // Nothing leaves the browser until a real CF7 form is set in the Customizer.
    const submit = $('button[type="submit"]', form);
    const label = submit.textContent;
    const address = email.value.trim();
    submit.disabled = true;
    submit.setAttribute("aria-busy", "true");
    submit.textContent = form.dataset.sending || "…";
    setTimeout(() => {
      $(".js-signup-email", form).textContent = address;
      $(".js-signup-fields", form).hidden = true;
      $(".js-signup-success", form).hidden = false;
      submit.disabled = false;
      submit.removeAttribute("aria-busy");
      submit.textContent = label;
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 1300);
  });
}
